import React, { Component } from 'react';
import { ButtonGroup, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import i18n from './Localization';
import { TOOLTIP_DELAY } from './Xword';

class HelpButton extends Component {

  constructor() {
    super();
    this.state = {
      show_modal: false
    }
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  open() {
    this.setState({show_modal: true});
    window.addEventListener("keydown", this.onKeyDown);
  }

  close() {
    this.setState({show_modal: false});
    window.removeEventListener("keydown", this.onKeyDown);
  }

  print(printFn) {
    printFn(this.state.selected);
    this.close();
  }

  onKeyDown = (e) => {
    switch (e.key) {
      case "Enter":
        this.close();
        break;
    }
  }

  render() {
    return (
      <ButtonGroup>
        <OverlayTrigger delay={TOOLTIP_DELAY} placement="bottom" overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">{i18n.t("helpTooltip")}</Tooltip>}>
          <Button variant="light" className="xwordjs-help-button" size="sm" onClick={this.open}>
            <i className="icon fa fa-question" />
          </Button>
        </OverlayTrigger>

        <Modal show={this.state.show_modal} onHide={this.close} >
          <Modal.Header closeButton>
            <Modal.Title>{i18n.t("helpTitle")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className="xwordjs-print-menu">
            <ul>
              <li dangerouslySetInnerHTML={{__html: i18n.t("help01")}} />
              <li dangerouslySetInnerHTML={{__html: i18n.t("help02")}} />
              <li dangerouslySetInnerHTML={{__html: i18n.t("help03")}} />
              <li dangerouslySetInnerHTML={{__html: i18n.t("help04")}} />
              <li dangerouslySetInnerHTML={{__html: i18n.t("help05")}} />
              <li dangerouslySetInnerHTML={{__html: i18n.t("help06")}} />
              <li dangerouslySetInnerHTML={{__html: i18n.t("help07")}} />
              <li dangerouslySetInnerHTML={{__html: i18n.t("help08")}} />
              <li dangerouslySetInnerHTML={{__html: i18n.t("help09")}} />
            </ul>
          </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal>
      </ButtonGroup>);
  }
}

export default HelpButton;
